import { useAuth } from "@clerk/clerk-react";
import useSWR from "swr";
import { TLog } from "../types/Devices";
import { fetcher } from "../utils/axios";

const useDeviceTankReport = (id: string) => {
  const { getToken } = useAuth();

  const { data, error, mutate } = useSWR(
    id ? `/devices/${id}/report-tank` : null,
    async (url) => {
      const token = await getToken();
      const result = await fetcher(url, token);
      return result;
    },
    {
      refreshInterval: 60000, // Refresh every minute
    }
  );

  // Data is already filtered and limited to 9 readings by the backend
  const filteredEvents = (data as TLog[]) || [];

  return {
    events: filteredEvents,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export { useDeviceTankReport };
